import { createTheme } from '@mui/material/styles';
import { indigo, lightBlue } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: lightBlue[600],
    },
    secondary: {
      main: indigo[500],
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '12px',
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontSize: '12px !important',
        },
      },
    },
  },
});

export default theme;
